import * as React from "react";
import Box from "@mui/material/Box";
import Button from "../components/Button";
import Typography from "../components/Typography";
import ProductHeroLayout from "./ProductHeroLayout";

import en from "../../../data/en.json";

export default function ProductHero() {
  return (
    <React.Fragment>
      <ProductHeroLayout alignLeft>
        <Box
          sx={{
            position: "absolute",
            top: { xs: "15%", sm: "20%" }, // Responsive top positioning
            left: { xs: "5%", sm: "8%" }, // Responsive left positioning
            zIndex: 2,
            textAlign: "left",
            color: "black",
            maxWidth: { xs: "90vw", sm: "650px" }, // Responsive max width
            mt: { xs: "2vh", sm: "5vh" }, // Responsive margin top
          }}
        >
          {/* "WELCOME TO" */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 200,
              letterSpacing: "1px",
              fontSize: { xs: "1.5rem", sm: "2.125rem" },
            }}
          >
            WELCOME TO
          </Typography>

          {/* "INK" in Blue & "BOWL" in Black */}
          <Typography
            variant="h2"
            sx={{ fontWeight: 400, fontSize: { xs: "2.5rem", sm: "3.75rem" } }}
          >
            <span style={{ color: "#253D97" }}>INK</span>BOWL
          </Typography>

          {/* Subtext */}
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "1rem", sm: "1.2rem" }, // Responsive font size
              lineHeight: "1.6",
              marginTop: 2,
              maxWidth: { xs: "45ch", sm: "50ch" }, // Fixed character width to prevent awkward wrapping
            }}
          >
            An AI-Powered hub for comprehensive student-centered academic,
            creative & career achievement.
          </Typography>
          {/* Button */}
          <Button
            variant="contained"
            href="/about"
            sx={{
              backgroundColor: "black",
              color: "white",
              textTransform: "none",
              fontSize: { xs: "0.9rem", sm: "1rem" }, // Responsive button font size
              padding: { xs: "6px 16px", sm: "8px 20px" }, // Responsive padding
              marginTop: 3,
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
          >
            {en.marketing.learnMore}
          </Button>
        </Box>
      </ProductHeroLayout>
    </React.Fragment>
  );
}
